import { Plugin } from '@segment/analytics-next'
import { getUTMPayload } from '../../services/UTMService'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'

const SegmentInjectUTMPlugin: Plugin = {
  name: 'SegmentInjectUTMPlugin',
  type: 'enrichment',
  version: '1.0.0',

  isLoaded: () => true,

  load: () => Promise.resolve(),

  track: ctx => {
    try {
      if (ctx.event.type === 'identify') {
        return ctx
      }
      const { isEnabled = false } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_FIVE) ?? {}
      if (isEnabled) {
        const utmPayload = getUTMPayload()

        if (utmPayload) {
          ctx.updateEvent('properties.utmCampaign', utmPayload.utm_campaign)
          ctx.updateEvent('properties.utmSource', utmPayload.utm_source)
          ctx.updateEvent('properties.utmMedium', utmPayload.utm_medium)
          ctx.updateEvent('properties.utmTerm', utmPayload.utm_term)
          ctx.updateEvent('properties.utmContent', utmPayload.utm_content)
        }
      }
    } catch (error) {
      console.error('Error in SegmentInjectUTMPlugin:', error)
    }
    return ctx
  },
}

export default SegmentInjectUTMPlugin
